import React from 'react';
import styled from 'styled-components';

const StyledBetaTagWrapper = styled.div`
    position: relative;
    display: inline-block;
    padding-right: 32px;
    width: 100%;

    .beta-tag {
        color: white !important;
    }
`;

const BetaTagWrapper = ({ children }) => {
    return <StyledBetaTagWrapper className="beta-tag-wrapper">{children}</StyledBetaTagWrapper>;
};

export default BetaTagWrapper;
